import { PRICE_TYPES } from 'shared/consts/productTemplates'
import type { PageType } from 'types/cmsTypes'
import getImageUrl from 'views/components/organisms/AlgoliaInstantSearch/Algolia/getImageUrl'
import buildClientAPI from 'views/providers/clientAPI'
import { calculateRetailPrice } from 'views/utils/esCompatibilityUtils'

import { EXCLUDED_PAGE_TYPES } from './consts'
import { type SearchHistorySuggestion, type SearchHit } from './types'

export const convertHitToSuggestion = ({
  cdnUrl,
  product,
  queryID,
  isRebrandingEnabled,
  placeholderFromCdn,
}: {
  cdnUrl: string
  product: SearchHit
  queryID?: string
  isRebrandingEnabled?: boolean
  placeholderFromCdn?: boolean
}): SearchHit => {
  const {
    productName: name,
    pzn: id,
    price,
    averageRating,
    deeplink,
    variants,
    objectID,
    prescriptionMedicine,
    hasVariants,
  } = product

  let lowestPrice = Number(price)
  let newName = name
  let newDeepLink = deeplink

  variants?.forEach(({ retailPrice, productName, webDetailPath }) => {
    if (lowestPrice > Number(retailPrice)) {
      lowestPrice = Number(retailPrice)
      newName = productName
      newDeepLink = webDetailPath
    }
  })

  return {
    id,
    queryID,
    objectID,
    deeplink: newDeepLink,
    name: newName,
    averageRating,
    prices: [
      {
        amount: lowestPrice ? calculateRetailPrice(lowestPrice) : price,
        type: PRICE_TYPES.RETAIL,
      },
    ],
    thumbnailURL: getImageUrl({
      product,
      cdnUrl,
      isRebrandingEnabled,
      placeholderFromCdn,
    }),
    prescriptionMedicine,
    hasVariants,
  }
}

export const convertHitToHistorySuggestion = ({
  product,
  queryID,
}: {
  product: SearchHit
  queryID?: string
}): SearchHistorySuggestion => ({
  queryID,
  ...product,
})

export const fetchPreQuerySearchSuggestions = async (): Promise<{
  topSearches: []
  topProductsSuggestions: []
}> => {
  const { clientFockService } = buildClientAPI()
  let suggestions: { topSearches: []; topProductsSuggestions: [] } = {
    topSearches: [],
    topProductsSuggestions: [],
  }
  try {
    const response = await fetch(
      clientFockService.getPreQuerySearchSuggestionDataPath()
    )
    suggestions = (await response.json()) ?? {
      topSearches: [],
      topProductsSuggestions: [],
    }
  } catch (e) {
    suggestions = { topSearches: [], topProductsSuggestions: [] }
  }

  return suggestions
}

export const shouldRenderPqsl = (pageType?: PageType): boolean =>
  typeof pageType !== 'undefined' && !EXCLUDED_PAGE_TYPES.includes(pageType)
